// Accesibilidad con teclado (29/10/2026).
//
// clickable(fn): para tarjetas y cabeceras que se pulsan pero no son <button>
// (div con onClick). Las hace alcanzables con Tab y activables con Intro o
// Espacio, y las anuncia como botón al lector de pantalla. Solo reacciona a
// teclas pulsadas sobre el propio elemento, no sobre un botón que lleve dentro.
export function clickable(fn) {
  return {
    role: 'button',
    tabIndex: 0,
    onClick: fn,
    onKeyDown: (e) => {
      if (e.target !== e.currentTarget) return
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(e) }
    },
  }
}

// Escape cierra la ventana emergente que esté encima. Todas se cierran al
// pulsar su fondo, así que basta con "pulsar" el último fondo abierto.
const BACKDROPS = '.pd-sheet-bg, .tm-moment, .mp-moment, .ppc-guide-bg, .share-overlay-backdrop'

export function installEscapeToClose() {
  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || e.defaultPrevented) return
    const open = document.querySelectorAll(BACKDROPS)
    if (open.length) open[open.length - 1].click()
  })
}
